// @flow
import React from 'react';
import moment from 'moment-timezone';

import CafeteriaSubsidiesData from '../../../CafeteriaSubsidiesData';
import ItemDetailsView from './ItemDetailsView';


export const dateFormat = 'YYYY-MM-DD';

type Props = {
  subsidyOrderId: number,
  subsidyOrderNumber?: string,
  lastUsage: string,
  personId: number,
  timezone: string,
  schoolId?: number,
}

const ItemDetails = ({
  subsidyOrderId,
  subsidyOrderNumber,
  lastUsage,
  personId,
  timezone,
  schoolId,
}: Props) => {
  const from = moment(lastUsage, dateFormat).subtract(2, 'month').format(dateFormat);
  const to = lastUsage;

  return (
    <CafeteriaSubsidiesData
      timezone={timezone}
      personId={personId}
      schoolId={schoolId}
      from={from}
      to={to}
    >
      <ItemDetailsView
        subsidyOrderId={subsidyOrderId}
        subsidyOrderNumber={subsidyOrderNumber}
      />
    </CafeteriaSubsidiesData>
  );
};

export default ItemDetails;
